"use client";

import * as React from "react";
import Box from "@mui/material/Box";
import { useColorScheme } from "@mui/material/styles";

import { NoSsr } from "@/components/core/no-ssr";

const HEIGHT = 60;
const WIDTH = 60;

export function Logo({ color = "dark", emblem, height = HEIGHT }) {
	const textColor = color === "light" ? "var(--mui-palette-common-white, #FBFBFB)" : "var(--mui-palette-text-primary, #1B2430)";

	return (
		<Box
			aria-label="WealthInsider"
			sx={{
				alignItems: "center",
				color: textColor,
				display: "inline-flex",
				fontSize: emblem ? "1.1rem" : "1.0625rem",
				fontWeight: 700,
				height,
				letterSpacing: "-0.02em",
				lineHeight: 1,
				userSelect: "none",
				whiteSpace: "nowrap",
			}}
		>
			{emblem ? "WI" : "WealthInsider"}
		</Box>
	);
}

export function DynamicLogo({ colorDark = "light", colorLight = "dark", height = HEIGHT, width = WIDTH, ...props }) {
	const { colorScheme } = useColorScheme();
	const color = colorScheme === "dark" ? colorDark : colorLight;

	return (
		<NoSsr fallback={<Box sx={{ height: `${height}px`, width: `${width}px` }} />}>
			<Logo color={color} height={height} width={width} {...props} />
		</NoSsr>
	);
}
